import React, { useEffect, useState, useCallback } from 'react';
import moment from 'moment';
import * as S from './style';
import { FormStatusInfo, Label, Btn } from 'components';
import { ReactComponent as ImgInterviewNotice } from 'assets/img/status/img_interview_notice.svg';
import { ReactComponent as CheckOn } from 'assets/img/common/btn_checkbox_on.svg';
import { ReactComponent as CheckOff } from 'assets/img/common/btn_checkbox_off.svg';

import { BUTTON_CONFIRM } from 'commons/ZimssaString';

interface Props {
  interviewDate?: string;
  isAnswer?: boolean;
  onClick?: (e: React.MouseEvent<HTMLButtonElement, MouseEvent>) => void;
}

function InterviewNotice({
  interviewDate,
  isAnswer = false,
  onClick,
}: Props): React.ReactElement {
  const [checked, setChecked] = useState<boolean>(isAnswer);

  const onClickCallback = useCallback(
    (e: React.MouseEvent<HTMLButtonElement, MouseEvent>) => {
      setChecked(!checked);
    },
    [checked]
  );

  useEffect(() => {
    setChecked(isAnswer);
  }, [isAnswer]);

  return (
    <FormStatusInfo
      title={['인터뷰 안내']}
      subTitle={['인터뷰 예상일']}
      image={<ImgInterviewNotice />}
      btn={
        <Btn
          height={64}
          fontStyle={'body1_bold'}
          backGroundColor={checked ? 'blue_900' : 'gray_opacity_200'}
          color={checked ? 'gray_opacity_50' : 'gray_opacity_300'}
          onClick={checked ? onClick : () => {}}
        >
          {BUTTON_CONFIRM}
        </Btn>
      }
      inHomeBtn={true}
    >
      <S.DateWrapper>
        <Label
          fontStyle={'h4'}
          color={'blue_900'}
          contents={
            interviewDate
              ? moment(interviewDate).format('YYYY년 MM월 DD일')
              : '-'
          }
        />
      </S.DateWrapper>
      <S.CaptionWrapper>
        {[
          "하단의 '인터뷰 참여' 버튼을 눌러주시면 짐싸 파트너 가입 인터뷰에 참여하시는 걸로 간주하고 인터뷰 예상일에 연락 드릴 수 있도록 하겠습니다.",
        ].map((item, index) => (
          <Label
            key={index}
            contents={item}
            color={'gray_opacity_600'}
            fontStyle={'body2'}
          />
        ))}
      </S.CaptionWrapper>
      <S.BtnInterviewWrapper>
        <Btn
          backGroundColor={'gray_opacity_50'}
          boarderColor={checked ? 'blue_900' : 'gray_opacity_200'}
          color={checked ? 'blue_900' : 'gray_opacity_600'}
          fontStyle={'body2'}
          height={52}
          onClick={onClickCallback}
        >
          <S.BtnContentsWrapper>
            {checked ? <CheckOn /> : <CheckOff />} {'인터뷰 참여'}
          </S.BtnContentsWrapper>
        </Btn>
        <Label
          color={'blue_900'}
          fontStyle={'caption'}
          contents={
            '*인터뷰 예상일 이내에 인터뷰 참여 버튼을 누르지 않을 경우 미응답 기사님으로 분류됩니다. 이 때 인터뷰를 원할 경우 서류 재심사가 이루어질 수 있습니다.'
          }
        />
      </S.BtnInterviewWrapper>
    </FormStatusInfo>
  );
}

export default InterviewNotice;
